<div [formGroup]="form">
  <mojo-select
    class="configured status-assign"
    [multiple]="true"
    [options]="hmStatuses"
    [disableOptionCentering]="true"
    [disableRipple]="true"
    panelClass="status-select"
    [color]="'secondary'"
    [isDisabled]="false"
    (selection)="hmStatusesSelected($event)"
    formControlName="filter"
  >
  </mojo-select>
</div>
